(function () {
  function getSelectedVariant(productInfo) {
    var script = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getOptionNames(productInfo) {
    var names = [];
    var groups = productInfo.querySelectorAll(
      'variant-selects > fieldset, variant-selects > div.product-form__input--dropdown'
    );
    groups.forEach(function (el) {
      var label = el.querySelector('legend') || el.querySelector('label');
      var text = label ? label.textContent : '';
      var selSpan = label ? label.querySelector('[data-selected-value]') : null;
      if (selSpan) text = text.replace(selSpan.textContent, '');
      text = text.replace(/:\s*$/, '').trim().toLowerCase();
      names.push(text);
    });
    return names;
  }

  function getSelectedColor(productInfo) {
    var variant = getSelectedVariant(productInfo);
    if (!variant) return null;
    var names = getOptionNames(productInfo);
    var idx = names.indexOf('color');
    if (idx === -1) return null;
    return variant['option' + (idx + 1)] || null;
  }

  function applyFilter(productInfo) {
    var gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;

    var color = getSelectedColor(productInfo);
    if (!color) return;

    var items = gallery.querySelectorAll('li[data-media-id]');
    if (!items.length) return;

    var colorAlts = new Set();
    items.forEach(function (li) {
      var alt = (li.getAttribute('data-media-alt') || '').trim();
      if (alt) colorAlts.add(alt);
    });

    // Only filter when the selected color is actually one of the tagged photo colors,
    // so untouched products (no alt tagging yet) are left showing everything as before.
    if (!colorAlts.has(color)) return;

    items.forEach(function (li) {
      var alt = (li.getAttribute('data-media-alt') || '').trim();
      var shouldShow = alt === '' || alt === color;
      if (shouldShow) {
        if (li.style.display === 'none') li.style.removeProperty('display');
      } else {
        if (li.style.display !== 'none') li.style.display = 'none';
      }
    });
  }

  function observe(productInfo) {
    if (productInfo._lozelGalleryObserved) return;
    productInfo._lozelGalleryObserved = true;

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applyFilter(productInfo);
      });
    }

    // Re-run the filter whenever Dawn rewrites the gallery list or the selected-variant
    // script tag, however that update was triggered (AJAX swap, pub/sub, anything else).
    var observer = new MutationObserver(schedule);
    observer.observe(productInfo, { childList: true, subtree: true, attributes: true });

    schedule();
  }

  function init(root) {
    (root || document).querySelectorAll('product-info').forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
